import { Typography } from "antd";

const { Text } = Typography;
import { TextOverrideSkeleton } from "../TextOverrideSkeleton";

import * as theme from "./IconTimelineItem.css";

interface IconTimelineItemProps {
    date: string | undefined;
    label: string;
    isPending?: boolean;
    isNotApplicable?: boolean;
    notApplicableLabel?: string;
}
export function IconTimelineItem({
    date,
    label,
    isPending,
    isNotApplicable,
    notApplicableLabel = "",
}: IconTimelineItemProps) {
    return (
        <div className={theme.root}>
            <Text strong>{label}</Text>
            {date ? (
                <Text>{date}</Text>
            ) : (
                <TextOverrideSkeleton
                    overrideText={
                        isNotApplicable ? notApplicableLabel : undefined
                    }
                    enableAnimation={!!isPending}
                    width={120}
                />
            )}
        </div>
    );
}
